import { toast } from 'react-toastify';

export type RentRollConfirmErrorAction = {
  clearPreview: boolean;
  returnToColumnMapping: boolean;
};

const NO_ACTION: RentRollConfirmErrorAction = {
  clearPreview: false,
  returnToColumnMapping: false
};

/**
 * Shared 409/410/404 handling for confirming a rent-roll preview, used by both the
 * single-building and multi-building upload flows. Shows the appropriate toast and
 * tells the caller what to do with its local currentStep/preview state — those stay
 * container-local since the two flows track them differently (singular vs. array).
 */
export const handleRentRollConfirmError = (
  err: any,
  { pluralBuildings = false }: { pluralBuildings?: boolean } = {}
): RentRollConfirmErrorAction => {
  const rosterChangedSuffix = pluralBuildings
    ? ' for one or more buildings'
    : '';

  switch (err?.status) {
    case 409:
      toast.error(
        `The resident roster changed${rosterChangedSuffix} since this preview was generated. Please re-run the preview.`
      );
      return { clearPreview: true, returnToColumnMapping: true };
    case 410:
      toast.error('This preview has expired. Please re-run the preview.');
      return { clearPreview: true, returnToColumnMapping: true };
    case 404:
      toast.error('This import was already processed or could not be found.');
      return { clearPreview: true, returnToColumnMapping: false };
    default:
      return NO_ACTION;
  }
};
